"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropHouseProvider = exports.PropHouseContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdk_1 = require("@prophouse/sdk");
const react_1 = __importStar(require("react"));
const providers_1 = require("@ethersproject/providers");
const wagmi_1 = require("wagmi");
const publicClientToProvider = (publicClient) => {
    const { chain, transport } = publicClient;
    const network = {
        chainId: chain.id,
        name: chain.name,
        ensAddress: chain.contracts?.ensRegistry?.address,
    };
    if (transport.type === 'fallback')
        return new providers_1.FallbackProvider(transport.transports.map(({ value }) => new providers_1.JsonRpcProvider(value?.url, network)));
    return new providers_1.JsonRpcProvider(transport.url, network);
};
const walletClientToSigner = (walletClient) => {
    const { account, chain, transport } = walletClient;
    const network = {
        chainId: chain.id,
        name: chain.name,
        ensAddress: chain.contracts?.ensRegistry?.address,
    };
    const provider = new providers_1.Web3Provider(transport, network);
    const signer = provider.getSigner(account.address);
    return signer;
};
const useEthersProvider = ({ chainId } = {}) => {
    const publicClient = (0, wagmi_1.usePublicClient)({ chainId });
    return react_1.default.useMemo(() => publicClientToProvider(publicClient), [publicClient]);
};
const useEthersSigner = ({ chainId } = {}) => {
    const { data: walletClient } = (0, wagmi_1.useWalletClient)({ chainId });
    return {
        data: react_1.default.useMemo(() => (walletClient ? walletClientToSigner(walletClient) : undefined), [walletClient]),
    };
};
exports.PropHouseContext = (0, react_1.createContext)(undefined);
const PropHouseProvider = ({ children, ...props }) => {
    const provider = (0, wagmi_1.useProvider)?.() || useEthersProvider();
    const { data: signer } = (0, wagmi_1.useSigner)?.() || useEthersSigner();
    const [propHouse, setPropHouse] = (0, react_1.useState)(new sdk_1.PropHouse({
        ...props,
        evmChainId: provider.network.chainId,
        evm: signer || provider,
    }));
    (0, react_1.useEffect)(() => {
        if (!provider && !signer)
            return;
        setPropHouse(propHouse.attach(signer || provider));
    }, [provider, signer]);
    return ((0, jsx_runtime_1.jsx)(exports.PropHouseContext.Provider, { value: propHouse, children: children }));
};
exports.PropHouseProvider = PropHouseProvider;
